/**
 * Fetches the given key from the given dictionary if it exists, or else calls
 * the given function to produce a value, inserts it into the given dictionary
 * with the given key,and returns that value.
 */
export function getOrCreate<V>(d: Dictionary<V>, key: string, vProducer: () => V): V;
export function getOrCreate<V>(d: NumericDictionary<V>, key: number, vProducer: () => V): V;
export function getOrCreate<V>(d: Dictionary<V>, key: string | number, vProducer: () => V): V {
  let v = d[key];
  if (!v) {
    v = d[key] = vProducer();
  }
  return v;
}
